import { Box } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import SimpleEntity from '../../logic/physics/SimpleEntity'
import { shape } from '../../theme'
import HealthBar from './HealthBar'


export default function SelectedEntity({ entity = undefined as (undefined | SimpleEntity) }) {

	const [healthRatio, setHealthRatio] = useState<number>(1)

	useEffect(() => {

		if (entity) {
			const interval = setInterval(() => {
				setHealthRatio(entity.health / entity.maxHealth)
			}, 100)

			return () => {
				clearInterval(interval)
			}
		}

	}, [entity])

	return (
		<>
			{entity && (
				<Box display="flex" gridGap="8px" color="white" alignItems="center" bgcolor="rgba(255,255,255,0.25)" borderRadius={shape.borderRadius} overflow="hidden" p="0 8px">
					<Box display="flex">{entity.symbol}</Box>
					<Box display="flex">{entity.getName()}</Box>
					<Box display="flex"><HealthBar progress={healthRatio} /></Box>
				</Box>
			)}
		</>
	)
}
